export { default } from './SectionImage.jsx'
